import Button from "components/Button";
import React from "react";
import { useHistory } from "react-router-dom";

type Props = {
  icon: string;
  groupId: string;
  groupName: string;
  isMemberData?: boolean;
};

const Header: React.FC<Props> = ({
  icon,
  groupId,
  groupName,
  isMemberData,
}): JSX.Element => {
  let history = useHistory();

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-col mt-20">
        <span
          className="font-nunito text-2xl ml-2"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#4A4A4A",
          }}
        >
          Channels
        </span>
      </div>
      <div className="flex flex-col">
        <Button
          label={!isMemberData ? "Add member" : "Edit"}
          className={`h-14 w-40 text-base bg-bt-green text-white rounded-full font-sora font-medium2`}
          iconLeft={icon}
          onClick={() => {
            history.push(`/manage-families/${groupId}/update-families`, {
              groupName,
            });
          }}
        />
      </div>
    </div>
  );
};

export default Header;
